export default __webpack_public_path__ + "087624c44bb766c6d005cff3f189345f.png";